import { STATUS } from "#candidate/constants"
import { useRefreshCandidate, useSetCandidate } from "#candidate/redux/actions"
import { candidateIdInterviewPost, candidateQuestionsGet } from "#candidate/services/api"
import { SkeletonSquare } from "#common/Skeleton"
import ErrorResponse from "#core/pages/ErrorResponse"
import Evaluation, {
	validateDataInterview,
} from "#evaluation/components/evaluation/Evaluation"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import { useSetVacancy } from "#vacancy/redux/actions"
import { Box, Button, Paper, Typography } from "@mui/material"
import { ChangeTitle } from "Components/menu/funciones"
import { useEffect, useMemo, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"

export default function EvaluationInterview() {
	const { candidateId } = useParams()
	ChangeTitle("Entrevista")
	const [values, setValues] = useState()
	const [disabled, setDisabled] = useState()
	// const { vacancy } = useVacanteRedux()
	// const { candidate } = useCandidateRedux()
	const { refresh } = useRefreshCandidate()
	const navigate = useNavigate()
	const params = useMemo(() => ({ id: candidateId }), [candidateId])
	const { data, loading, error } = useApi(candidateQuestionsGet, {
		autoFetch: true,
		params,
	})
	const questions = useMemo(() => data?.questions || [], [data])
	const candidate = useMemo(() => data?.candidate || [], [data])
	const vacancy = useMemo(() => {
		return data?.vacancy || []
	}, [data])
	useSetCandidate(candidate)
	useSetVacancy(vacancy)

	useEffect(() => {}, [vacancy])

	const success = () => {
		navigate(-1)
		refresh()
	}

	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(candidateIdInterviewPost, { success, end })

	let interviewRh = null

	if (STATUS.SCHEDULED_BY_HR === candidate.status) interviewRh = true
	if (STATUS.SCHEDULED_BY_BOSS === candidate.status) interviewRh = false

	if (loading) return <SkeletonSquare height="80vh" />
	if (error) return <ErrorResponse api={error} />

	if (interviewRh == null)
		return (
			<Box p={2} textAlign="center">
				<Typography variant="h5">No Puedes realizar la evaluacion</Typography>
			</Box>
		)

	return (
		<Box
			component={Paper}
			display="flex"
			justifyContent="center"
			gap={2}
			flexDirection="column"
		>
			<Evaluation
				{...{
					questions,
					interviewRh,
					values,
					setValues,
					perfilPuesto: vacancy?.perfil_puesto,
				}}
			/>
			<ButtonSend
				{...{
					disabled,
					values,
					interviewRh,
					fetch,
					candidate,
					setDisabled,
				}}
			/>
		</Box>
	)
}
const ButtonSend = ({ disabled, values, interviewRh, fetch, candidate, setDisabled }) => {
	if (values?.interview?.evaluator_type !== 3 && interviewRh) return null
	if (values?.interview?.evaluator_type !== 2 && !interviewRh) return null

	return (
		<Box display="flex" gap={2} p={2} alignItems="center" justifyContent="center">
			<Button
				disabled={disabled}
				onClick={() => {
					if (!validateDataInterview(values, interviewRh)) return
					setDisabled(true)
					fetch(candidate.id, values)
				}}
			>
				Enviar
			</Button>
		</Box>
	)
}
